<div class="flex flex-column consult__section consult__recipe">
  <div class="consult__section-subheading-group">
    <h3 class="col-12 inline-flex align-items-center p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer">{{screen.heading}}:</label>
    </h3>
  </div>

  <ng-container *ngIf="expandSection">
    <div class="flex flex-wrap col-12 p-0" *ngIf="!readonly">
      <label class="col-12 px-0 mt-2" for="medicine-atc">
        Ingresa el nombre del compuesto o nombre comercial del medicamento para buscar coincidencias
      </label>

      <div class="col-12 px-0">
        <p-autoComplete name="medicine-atc" [(ngModel)]="selected" [suggestions]="suggestions"
          (completeMethod)="handleSearchSuggestions($event)" (onSelect)="handleMedicineSelected($event)" field="label"
          [group]="true" optionGroupChildren="children" [forceSelection]="true" appendTo="body">
          <ng-template let-recipe pTemplate="item">
            <span class="inline-flex flex-wrap" *ngIf="!recipe.quantity && !recipe.instructions">
              <span class="col-12 p-0">
                (<b>Compuesto:</b> {{recipe.atcName}}) - <i>{{recipe.name}}</i>
              </span>
            </span>
            <span class="inline-flex flex-wrap" *ngIf="recipe.quantity || recipe.instructions">
              <span class="col-12 p-0">
                (<b>Compuesto:</b> {{recipe.atcName}}) - <b>Nombre comercial:</b> {{recipe.name}} - <b>Cantidad:</b>
                {{recipe.quantity}}
              </span>
              <span class="col-12 p-0" *ngIf="recipe.instructions && recipe.instructions !== ''">
                <b>Indicaciones:</b>{{recipe.instructions}}
              </span>
            </span>
          </ng-template>
        </p-autoComplete>
      </div>
    </div>

    <div class="flex hide-on-small" *ngIf="recipe.length > 0">
      <div class="col-fixed px-0" [style.width.px]="50" *ngIf="!readonly"></div>
      <label class="col-3 pl-0 no-margin" for="recipe_medicine_0_{{turn}}">{{screen.medicine}}</label>
      <label class="col-3 no-margin" for="recipe_qty_0_{{turn}}">{{screen.quantity}}</label>
      <label class="col no-margin" for="recipe_instructions_0_{{turn}}">{{screen.instructions}}</label>
    </div>

    <div *ngFor="let rItem of recipe; let idx = index">
      <ms-consult-recipe-item [turn]="turn" [idx]="idx" [recipe]="rItem" (recipeChange)="addUpdateRecipe($event)"
        (remove)="removeRecipe(idx)" [readonly]="readonly">
      </ms-consult-recipe-item>
      <hr class="hide-from-small" />
    </div>

    <div class="align-self-end pt-2">
      <button pButton icon="fas fa-file-signature" [label]="screen.generate" type="button"
        class="p-button-warning p-button-outlined" (click)="generateRecipe()">
      </button>
    </div>
  </ng-container>
</div>

<ms-pdf-viewer [pdfFile]="recipeFile" [(show)]="showRecipePdf"></ms-pdf-viewer>